/**
 * Toast表示に関する設定定数
 * アプリケーション全体でtoastの表示設定を統一するための定数
 */
export const TOAST_CONFIG = {
  position: "top-right" as const,
  duration: 2000,
  expand: false,
  visibleToasts: 1
} as const;

export type ToastConfig = typeof TOAST_CONFIG;
